import { Col, Icon, Input, Row, Table as AntdTable } from 'antd';
import React from 'react';
import { connect } from 'react-redux';
import { TitledContainer } from '../../components/TitledContainer/TitledContainer';
import LoopBackEndpoint from '../../core-module/models/LoopBack/Models/LoopBackEndpoint';
import { defaultTableState } from '../../core-module/models/redux/DefaultTableState';
import {
  fetchCount,
  fetchTable,
  initState,
  setLoading,
  setPagination
} from '../../core-module/redux/Table/actions';

interface TableProps {
  stateKey: string;
  loopBackEndpoint: LoopBackEndpoint;
  filters: { filter: {} };
  columns: [];
  rowKey: string;
  state: typeof defaultTableState;
  initState: () => void;
  fetchTable: (filters?: {}) => void;
  setLoading: (loading: boolean) => void;
  fetchCount: () => void;
  setPagination: (pagination: typeof defaultTableState.pagination) => void;
  title?: string | undefined;
  striped?: boolean;
  bordered?: boolean;
  size?: 'small' | 'middle' | 'default';
  searchFields: string[];
  component: null;
  pagination: any;
  tableOnly?: boolean;
}

interface State {
  filters: any;
}

class TableWithModal extends React.Component<TableProps, State> {
  private timeout;

  constructor(props) {
    super(props);
    this.timeout = null;
  }

  public static defaultProps: Partial<TableProps> = {
    columns: [],
    rowKey: 'id',
    state: defaultTableState,
    striped: false,
    bordered: false,
    size: 'default'
  };

  public handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.props.state.pagination };
    pager.current = pagination.current;

    const order = this.getSorter(sorter);

    this.props.setPagination(pager);
    this.props.fetchTable({
      ...this.props.filters,
      filter: {
        ...this.props.filters.filter,
        order,
        limit: pager.pageSize,
        skip: pager.pageSize * (pager.current - 1)
      }
    });
  };
  private rowClassName = (record, index) => {
    return this.props.striped ? 'striped-table-row' : '';
  };
  private getSorter = (sorter) => {
    let order = '';
    if (Object.keys(sorter).length > 0) {
      const ascOrDesc = sorter.order === 'descend' ? 'DESC' : 'ASC';
      order = sorter.column.key + ' ' + ascOrDesc;
    }
    return order;
  };

  componentDidMount() {
    this.props.initState();
    if (this.props.loopBackEndpoint && this.props.loopBackEndpoint.getCountEndPoint() !== '') {
      this.props.fetchCount();
    }
    this.props.fetchTable(this.props.filters);
    if (this.props.pagination) {
      this.props.setPagination(this.props.pagination);
    }
  }

  onChange = (value) => {
    clearTimeout(this.timeout);
    const searchValue = value.target.getAttribute('value');
    const search = this.onSearch;

    // Make a new timeout set to go off in 800ms
    this.timeout = setTimeout(function () {
      search(searchValue);
    }, 400);
  };

  onSearch = (value) => {
    let searchFilters: any = null;

    if (value) {
      const clauses: Array<any> = [];
      const fields = this.props.searchFields.filter((item) => item.includes('.') === false);
      for (let i = 0; i < fields.length; i++) {
        clauses.push({ [fields[i]]: { like: `%25${value}%25` } });
      }

      searchFilters = {
        filter: {
          where: {
            or: clauses
          }
        }
      };
    }

    let theFilters: any = JSON.parse(JSON.stringify(this.props.filters)); // ...spread and obj.assign mutated the props.filters
    if (searchFilters) {
      theFilters.filter.where = { ...theFilters.filter.where, ...searchFilters.filter.where };
    }

    this.props.setLoading(true);
    this.props.fetchTable(theFilters);
  };

  renderExtraComponent() {
    return this.props.component;
  }

  render() {
    const { columns, state, rowKey, size, bordered } = this.props;
    let { tableData, pagination, loading } = state;

    return !this.props.tableOnly ? (
      <TitledContainer title={this.props.title}>
        <>
          {this.props.searchFields.length > 0 && (
            <Row style={{ marginBottom: 10 }}>
              <Col xs={24} sm={18}>
                {this.renderExtraComponent()}
              </Col>
              <Col xs={24} sm={6}>
                <Input
                  placeholder={'Zoek in tabel'}
                  onKeyUp={this.onChange}
                  suffix={<Icon type={'search'} />}
                />
              </Col>
            </Row>
          )}
          <AntdTable
            rowClassName={this.rowClassName}
            bordered={bordered}
            size={size}
            loading={this.props.state.loading}
            columns={columns}
            dataSource={tableData}
            rowKey={rowKey}
            onChange={this.handleTableChange}
            pagination={pagination}
            locale={{ emptyText: 'Geen data beschikbaar' }}
          />
        </>
      </TitledContainer>
    ) : (
      <>
        {this.props.searchFields.length > 0 && (
          <Row style={{ marginBottom: 10 }}>
            <Col xs={24} sm={18}>
              {this.renderExtraComponent()}
            </Col>
            <Col xs={24} sm={6}>
              <Input
                placeholder={'Zoek in tabel'}
                onKeyUp={this.onChange}
                suffix={<Icon type={'search'} />}
              />
            </Col>
          </Row>
        )}
        <AntdTable
          rowClassName={this.rowClassName}
          bordered={bordered}
          size={size}
          loading={loading}
          columns={columns}
          dataSource={tableData}
          rowKey={rowKey}
          onChange={this.handleTableChange}
          pagination={pagination}
          locale={{ emptyText: 'Geen data beschikbaar' }}
        />
      </>
    );
  }
}

const mapStateToProps = ({ table }, props) => {
  return {
    state: table.tables[props.stateKey]
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    initState: () => {
      dispatch(initState(props.stateKey, props.filters));
    },
    fetchTable: (filters = props.filters) => {
      dispatch(fetchTable(props.stateKey, props.endPoint, filters));
    },
    fetchCount: () => {
      dispatch(fetchCount(props.stateKey, props.loopBackEndpoint.getCountEndPoint()));
    },
    setPagination: (pagination) => {
      dispatch(setPagination(props.stateKey, pagination));
    },
    setLoading: (loading: boolean) => {
      dispatch(setLoading(props.stateKey, loading));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TableWithModal);
